<div>
{{status}}
</div>
<div>
    <a *ngIf="isLocked" (click)="unlock()">Unlock</a>
    <a *ngIf="isInactive" (click)="reactivate()">Re-activate</a>
</div>
